import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import EmailAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/email/email.entity";
import { ICreateBusinessPartnerEmail } from "./interfaces/create-business-partner-email.interface";
import { IUpdateBusinessPartnerEmail } from "./interfaces/update-business-partner-email.interface";
const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business_partner_email";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerEmailService extends AbstractService<
EmailAttributes,
ICreateBusinessPartnerEmail,
IUpdateBusinessPartnerEmail
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByBusinessId(businessId: string): Observable<IResult<EmailAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${businessId}`;
    return this.http.get<IResult<EmailAttributes>>(API_URL);
  }
}